import { useEffect, useState } from "react";
import { Dock } from "react-dock";

const DockContainer = ({ ident, children }) => {
	const [show, setShow] = useState(false);

	useEffect(() => {
		const handleOpen = () => {
			setShow((prevState) => !prevState);
		};
		window.addEventListener(ident, handleOpen);
		return () => {
			window.removeEventListener(ident, handleOpen);
		};
	}, [ident]);

	return (
		<Dock
			position="right"
			isVisible={show}
			fluid={false} // <- Interpreta `size` como pixel
			size={350} // <- Define largura fixa de 350px
			onVisibleChange={setShow}
			duration={300}
		>
			<div style={{ height: "100%", width: "100%" }}>{children}</div>
		</Dock>
	);
};

export default DockContainer;
